(() => {
  const menuSelector = 'products-mega-menu';
  const summarySelector = `${menuSelector} > details > summary`;
  const switchDelay = 320;
  let pendingMenu;
  let pendingTimer;

  const getOpenMenu = () =>
    [...document.querySelectorAll(`${menuSelector} > details[open]`)]
      .map((details) => details.closest(menuSelector))
      .find(Boolean);

  const clearPendingSwitch = () => {
    window.clearTimeout(pendingTimer);
    pendingMenu = undefined;
    pendingTimer = undefined;
  };

  const openMenu = (menu) => {
    document
      .querySelectorAll('[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]')
      .forEach((details) => details.removeAttribute('open'));

    menu.querySelector('details')?.setAttribute('open', '');
  };

  document.addEventListener(
    'mouseover',
    (event) => {
      const target = event.target;
      const summary = target.closest?.(summarySelector);
      const openMenuElement = getOpenMenu();

      if (openMenuElement && openMenuElement.contains(target)) {
        clearPendingSwitch();
        return;
      }

      if (!summary) return;

      const candidateMenu = summary.closest(menuSelector);
      if (!openMenuElement || openMenuElement === candidateMenu) {
        clearPendingSwitch();
        return;
      }

      // A multi-row desktop header can sit between a trigger and its panel.
      // Do not switch menus while the pointer is only passing across another
      // trigger; an intentional hover still opens that menu after this delay.
      event.stopPropagation();
      clearPendingSwitch();
      pendingMenu = candidateMenu;
      pendingTimer = window.setTimeout(() => {
        if (pendingMenu === candidateMenu) openMenu(candidateMenu);
        clearPendingSwitch();
      }, switchDelay);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      const summary = event.target.closest?.(summarySelector);
      if (!summary || pendingMenu !== summary.closest(menuSelector)) return;

      if (!summary.contains(event.relatedTarget)) clearPendingSwitch();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.(
        `${menuSelector} .products-mega-menu__item > a[href], ${menuSelector} .products-mega-menu__view-all > a[href]`
      );
      if (link) event.stopPropagation();
    },
    true
  );
})();
